import React from 'react';
import { styled } from '@compiled/react';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

const ReloadingSpinner = (): React.JSX.Element => (
	<SpinnerWrapper data-test-id="global-pages.home.common.ui.reloading-spinner">
		<Spinner />
	</SpinnerWrapper>
);

export default ReloadingSpinner;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerWrapper = styled.div({
	marginTop: token('space.negative.400'),
	position: 'absolute',
	right: token('space.100'),
});
